import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class ArcTeamGetArgs extends BaseGetArgs<ArcTeamGetArgs> {
  @Field(t => Int, { nullable: true })
  public teamMemberId?: number

  @Field(t => Int, { nullable: true })
  status?: number

  @Field(t => Int, { nullable: true })
  excludeTeamsUserIsAMemberOf?: number
}
